<template>
  <div class="navigation">
    <a href="/">
      <img
        class="navigation__logo"
        src="../../../src/assets/images/logo.svg"
        alt=""
      >
    </a>
    <navigation v-if="log" />
    <button
      v-if="log"
      :title="$t('create_push_notification')"
      class="add-push__btn desktop"
      @click="showAddPush"
    >
      <span>{{ $t('add_push') }}</span>
      <img
        src="../../assets/images/plus.svg"
        alt=""
      >
    </button>
    <multiselect
      v-model="selectedLanguage"
      class="multiselect-lang"
      :options="languageOptions"
      label="name"
      track-by="code"
      @input="changeLanguage"
    />
    <div
      v-if="log"
      class="logout"
      @click="logout"
    >
      <img
        src="../../assets/images/logout.svg"
        alt=""
      >
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/header/navigation.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "CustomHeader",
  components: {
    Multiselect,
    Navigation,
  },
  props: {
    login: {
      type: Boolean,
      default() {
        // eslint-disable-next-line vue/require-valid-default-prop
        return {};
      },
    },
  },
  data() {
    return {
      log: this.login,
      selectedLanguage: null,
      languageOptions: [
        { code: "en", name: this.$t("language_english") },
        { code: "ua", name: this.$t("language_ukrainian") }
      ]
    };
  },
  created() {
    this.selectedLanguage = this.languageOptions.find(
      lang => lang.code === this.$i18n.locale
    );
  },
  methods: {
    changeLanguage(selected) {
      this.$i18n.locale = selected.code;
      localStorage.setItem('locale', selected.code);
    },
    logout() {
      localStorage.removeItem("token");
      location.reload();
    },
    showAddPush() {
      this.$router.push({ name: "addPush" });
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: white;
  text-decoration: none;
}

.navigation {
  display: flex;
  color: white;
  align-items: center;
  justify-content: space-between;
  padding: 0 5vw;
  position: absolute;
  background: #333333;
  width: calc(100% - 10vw);
  height: 70px;
  z-index: 2;
  gap: 10px;

  ul {
    display: flex;
    &:first-child {
      flex-grow: 1;
    }
    li {
      padding-right: 1em;
    }
  }

  &__logo {
    width: auto;
    height: 50px;
  }

  @media only screen and (max-width: 767px) {
    overflow: hidden;
    padding: 0 15px;
    width: calc(100% - 30px);
  }
}

.brand {
  display: flex;
  align-items: center;
}

.logout {
  &:hover {
    cursor: pointer;
  }
}

.add-push__btn.desktop {
  background: blue;
  border: none;
  width: max-content;
  height: 40px;
  border-radius: 6px;
  color: #fff;
  font-family: HalvarR;
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 15px;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  gap: 10px;

  @media (max-width: 767px) {
    display: none !important;
  }
}
</style>

<style lang="scss">
.multiselect-lang {
  max-width: 150px;

  .multiselect__select {
    top: 11px!important;
    right: 0!important;
  }
}
</style>